import { Component, OnInit } from '@angular/core';

import { Control } from '../control';

@Component({
  selector: 'gk-control-link-factory',
  templateUrl: './control-link-factory.component.html',
  standalone: false,
})
export class ControlLinkFactoryComponent
  extends Control<string>
  implements OnInit
{
  href = '';
  label = '';

  override ngOnInit(): void {
    super.ngOnInit();
    this.initLinkHref();
    this.initLinkLabel();
  }

  hasHref(): boolean {
    return !!this.href;
  }

  getEvaluatedHref(): string {
    try {
      return eval(this.controlConfig.pathToValue);
    } catch (err) {
      console.error(
        'Incorrect pathToValue in controlLinkFactory:',
        this.controlConfig.pathToValue,
      );
      return '';
    }
  }

  initLinkHref(): void {
    this.href = this.getEvaluatedHref();
  }

  initLinkLabel(): void {
    this.label = eval(this.controlConfig.label);
  }
}
